import { useRef, useState } from "react";
import HmImg from "../../../Assets/Images/h_bg.png";
import { BsFillPlayCircleFill, BsFillPauseCircleFill } from "react-icons/bs";
import "./missionstatement.css";

const MissionStatement = () => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleVideoEnd = () => {
    setIsPlaying(false);
  };

  return (
    <div className="home-mission-container">
      <div className="home-mission-card">
        <div className="home-mission-left">
          <div className="home-mission-content">
            <h2 className="black-text-clip">Mission Statement</h2>
            <p className="black-text-clip">
              Because We Can is dedicated to providing all players with a
              supportive and judgment-free environment where they can learn and
              master the fundamentals of sports. Our mission is to foster a
              positive and inclusive atmosphere that encourages growth,
              teamwork, and a lifelong passion for athletics.
            </p>
          </div>
          <div className="hm-img">
            <img src={HmImg} alt="background" />
          </div>
        </div>
        <div className="home-mission-right" style={{ width: "100%" }}>
          <div className="responsive-youtube-video" style={{ height: "100%" }}>
            <iframe
              src="https://www.youtube.com/embed/83YHuVSOWK8?si=QpCqi4A0JCiNT-Vz"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>

      <div
        className="home-mission-mobile"
        style={{ width: "100%", display: "none" }}
      >
        <div className="" style={{ width: "100%" }}>
          <iframe
            style={{ width: "100%", height: "400px" }}
            src="https://www.youtube.com/embed/83YHuVSOWK8?si=QpCqi4A0JCiNT-Vz"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default MissionStatement;
